export function getMembers(families) {
    let members = [];
    for (const familyKey in families) {
        members = members.concat(families[familyKey].members.filter((member) => member["non-member"] === "N"));
    }
    return members;
}
